import toast from "react-hot-toast";
import { vendorService } from "../services";
import { VendorT } from "../types";


export const createVendor = async (data: VendorT) => {
    try {
      const res = await vendorService.post('/vendors', data);
      return res.data;
    } catch (e: any) {
      throw new Error(e.response?.data || e.message);
    }
  };

  export const getVendor = async (id: string) => {
    try {
      const res = await vendorService.get(`/vendors/${id}`);
      return res.data;
    } catch (e: any) {
      console.log(e.response.data);
      toast.error(e.response?.data || e.message);
      throw new Error(e.response?.data || e.message);
    }
  };


